import { isSuccess } from '@/context/services/type';
import { useDeleteInvoiceReport as useBaseDeleteInvoiceReport } from 'ap-openapi';
import { useCallback } from 'react';

export const useDeleteInvoiceReportService = () => {
  const { mutateAsync: _mutateAsync } = useBaseDeleteInvoiceReport();
  const mutateAsync = useCallback(
    async (id: string): Promise<boolean> => {
      const resp = await _mutateAsync({ id });
      if (isSuccess(resp.status)) return true;
      throw resp.data;
    },
    [_mutateAsync]
  );
  return { mutateAsync };
};
